// Flutter's onLongPress in a webview. Touch has no native long-press event, so
// this starts a timer on pointer-down and fires if the finger neither lifts nor
// moves for `ms`. It also maps right-click, so the same gesture works when the
// phone UI is opened in a desktop browser.
//
// Returns props to spread on the pressable element. The long-press suppresses
// the click that would otherwise follow.

import { useCallback, useRef } from 'react';

export default function useLongPress(onLongPress, onClick, ms = 500) {
  const timer = useRef(null);
  const fired = useRef(false);

  const start = useCallback(() => {
    fired.current = false;
    timer.current = setTimeout(() => {
      fired.current = true;
      onLongPress();
    }, ms);
  }, [onLongPress, ms]);

  const cancel = useCallback(() => {
    if (timer.current) { clearTimeout(timer.current); timer.current = null; }
  }, []);

  return {
    onPointerDown: start,
    onPointerUp: cancel,
    onPointerLeave: cancel,
    onPointerCancel: cancel,
    onContextMenu: (e) => { e.preventDefault(); cancel(); fired.current = true; onLongPress(); },
    onClick: (e) => {
      if (fired.current) { e.preventDefault(); e.stopPropagation(); fired.current = false; return; }
      if (onClick) onClick(e);
    },
  };
}
